export const config = {
  bazerAPI: 'https://auth.bazerwallet.com',
  p2pAPI: 'https://api.bazer-p2p-loans.com',
}